import {openCheckout, setupPaddle} from './Paddle';

export class PaymentsViewState {


    constructor() {
        setupPaddle();
    }

    subscribe() {
        openCheckout();
    }
}
